/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react';
import 'moment/locale/pt';
import { Box, Button, CircularProgress, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';

import InputMask from "react-input-mask";
import { removeCpfMask } from '../../../../utils/functions';
import { enqueueSnackbar } from 'notistack';
import { GetFetch, PostFetch } from '../../../../services/apiBase';

export default function NewClientModal({ onClose, getList }) {

  const [load, setLoad] = useState(false);
  const [errorValidation, setErrorValidation] = useState({});
  const [newCad, setNewCad] = useState({
    username: '',
    email: '',
    cnpj: '',
    ibge_code: '',
    county: '',
    name: '',
    number: '',
    postcode: '',
    supplement: '',
  })
  const [cities, setCities] = useState({})
  const [city, setCity] = useState({})
  const [state, setState] = useState({})
  const [validation, setValidation] = useState(true)

  const [cnpj, setCnpj] = useState('');

  const uf = [
    {label:"AC", value:"AC"},
    {label:"AL", value:"AL"},
    {label:"AP", value:"AP"},
    {label:"AM", value:"AM"},
    {label:"BA", value:"BA"},
    {label:"CE", value:"CE"},
    {label:"DF", value:"DF"},
    {label:"ES", value:"ES"},
    {label:"GO", value:"GO"},
    {label:"MA", value:"MA"},
    {label:"MT", value:"MT"},
    {label:"MS", value:"MS"},
    {label:"MG", value:"MG"},
    {label:"PA", value:"PA"},
    {label:"PB", value:"PB"},
    {label:"PR", value:"PR"},
    {label:"PE", value:"PE"},
    {label:"PI", value:"PI"},
    {label:"RJ", value:"RJ"},
    {label:"RN", value:"RN"},
    {label:"RS", value:"RS"},
    {label:"RO", value:"RO"},
    {label:"RR", value:"RR"},
    {label:"SC", value:"SC"},
    {label:"SP", value:"SP"},
    {label:"SE", value:"SE"},
    {label:"TO", value:"TO"}
  ]

  const handleOnChange = (e) => {
    let key = e.target.id
    let value = e.target.value
    setNewCad({ ...newCad, [key]: value })
  }

  const handleOnCloseModal = () => {
    onClose()
  }

  const handleSelectUF = async (e) => {
    const response = await GetFetch(`/subscription/listCity?code_uf=${e.target.value}`);
    setCities(response.data)
    setState(e.target.value)
  }
  
  const handleOnSelectCity = (e, id) => {
    setNewCad({...newCad, ibge_code: e.target.value })
    setErrorValidation({...errorValidation, 'city': false})
    setCity(e.target.value)
  }

  function validateForm() {
    if (newCad?.username.length <= 0) {
      return true;
    }

    if (newCad?.email.length <= 0) {
      return true;
    }

    if (cnpj.length <= 0) {
      return true;
    }

    if (newCad?.name.length <= 0) {
      return true;
    }

    if (newCad?.number.length <= 0) {
      return true;
    }

    if (newCad?.county.length <= 0) {
      return true;
    }

    if (newCad?.postcode.length <= 0) {
      return true;
    }

    if (newCad?.ibge_code.length <= 0) {
      return true;
    }

    return false;
  }

  const handleSubmit = async (e) => {
    try {
      setLoad(true)

      newCad.cnpj = removeCpfMask(cnpj)

      let payload = {
        username: newCad.username,
        email: newCad.email,
        cnpj: newCad.cnpj,
        address: {
          ibge_code: newCad.ibge_code,
          county: newCad.county,
          name: newCad.name,
          number: newCad.number,
          postcode: newCad.postcode,
          supplement: newCad.supplement,
        }
      }

      await PostFetch(`/subscription/institucionalSubscription`, payload);
      enqueueSnackbar('Novo cliente cadastrado com sucesso', { variant: 'success' });
      
      handleOnCloseModal()
      getList()
    } catch (error) {
      enqueueSnackbar('Erro ao cadastrar novo cliente', { variant: 'error' });
      
    } finally {
      setLoad(false)
    }
  }
  
  useEffect(() => {
    setValidation(validateForm())
  }, [newCad])

  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: 24,
      borderRadius: 2,
      backgroundColor: grey[300]
    }}>
      <Box sx={{
        padding: '16px',
        borderRadius: '8px 8px 0 0',
        backgroundColor: '#fff'
      }}>
        <Typography variant="h6" component="h2">
          Cadastrar novo cliente
        </Typography>
      </Box>

      <Box sx={{
        marginTop: '16px',
        marginBottom: '16px',
        marginRight: '32px',
        width: 800,
        minWidth: 800,
        maxHeight: '80%',
        height: '90%',
        width: '100%',
        backgroundColor: '#fff',
        borderRadius: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: 2,
        gap: 2
      }}>

        <Typography variant="h6" component="h2">
          Dados da instituição
        </Typography>

        <Box sx={{display: 'flex', gap: 2}}>
          <FormControl fullWidth>
            <TextField
              id={`username`}
              label="Nome da instituição"
              error={errorValidation?.username}
              onChange={(event) => {
                handleOnChange(event);
              }}
            />
          </FormControl>

          <FormControl fullWidth>
            <InputMask
              mask={"99.999.999/9999-99"}
              maskChar=" "
              value={cnpj}
              onChange={(event) => setCnpj(event.target.value)}
            >
              {() =>
                <TextField
                  error={errorValidation?.cnpj}
                  label="CNPJ"
                />
              }
            </InputMask>
          </FormControl>
        </Box>

        <FormControl fullWidth>
          <TextField
            id={`email`}
            label="E-mail"
            error={errorValidation?.email}
            onChange={(event) => {
              handleOnChange(event);
            }}
          />
        </FormControl>

        <Typography variant="h6" component="h2">
          Endereço
        </Typography>

        <FormControl fullWidth>
          <TextField
            id={`name`}
            label="Rua"
            error={errorValidation?.name}
            onChange={(event) => {
              handleOnChange(event);
            }}
          />
        </FormControl>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <FormControl fullWidth>
            <TextField
              id={`number`}
              label="Número"
              error={errorValidation?.number}
              onChange={(event) => {
                handleOnChange(event);
              }}
            />
          </FormControl>

          <FormControl fullWidth>
            <TextField
              id={`county`}
              label="Bairro"
              error={errorValidation?.county}
              onChange={(event) => {
                handleOnChange(event);
              }}
            />
          </FormControl>
        </Box>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <FormControl fullWidth>
            <TextField
              id={`supplement`}
              label="Complemento"
              onChange={(event) => {
                handleOnChange(event);
              }}
            />
          </FormControl>

          <FormControl fullWidth>
            <TextField
              id={`postcode`}
              label="CEP"
              onChange={(event) => {
                handleOnChange(event);
              }}
            />
          </FormControl>
        </Box>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <FormControl fullWidth>
            <InputLabel id="state">Estado</InputLabel>
            <Select
              labelId="state"
              id="state"
              name="state" 
              label="Estado"
              value={state}
              onChange={e => handleSelectUF(e)}
            >
              {uf.map(uf => (
                <MenuItem value={uf.value}>{uf.label}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel id="city">Cidade</InputLabel>
            <Select
              labelId="city"
              id="city"
              name="city" 
              label="Cidade"
              value={city}
              error={errorValidation?.city}
              onChange={e => handleOnSelectCity(e)}
            >
              {cities && cities.length > 0 ? (cities.map(city => (
                <MenuItem value={city.value}>{city.name_city}</MenuItem>
              )))
                : <MenuItem value={''}>{'Carregando...'}</MenuItem> }
            </Select>
          </FormControl>
        </Box>

      </Box>

      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        gap: 1,
        padding: 2,
        borderRadius: '0 0 8px 8px',
        backgroundColor: '#fff'
      }}>
        <Button disabled={validation || load} variant="contained" color={'success'}>
          <Typography color={'#fff'} onClick={() => handleSubmit()}>
            {load? <CircularProgress color='success' /> : 'Cadastrar'}
          </Typography>
        </Button>
        <Button variant="contained" color='error' onClick={onClose}>
          <Typography color={'#fff'}>
            Fechar
          </Typography>
        </Button>
      </Box>
    </Box>
  )
}
